<template>
  <div class="refer">
    <div class="refer-head">
      <div class="refer-head-text"></div>
      <div class="refer-title">奖 励 无 上 限</div>
    </div>
    <div class="refer-main">
      <div class="refer-form">
        <div class="refer-form__title">填写信息</div>
        <div class="refer-form__content">
          <div class="refer-form__row">
            <div class="refer-form__label">介绍人手机后六位:</div>
            <input
              class="refer-form__input"
              type="number"
              :value="mobile"
              @input="onMobileInput"
              placeholder="华夏卡预留手机后六位"
            />
          </div>
          <div class="refer-form__row">
            <div class="refer-form__label">介绍人证件后六位:</div>
            <input
              class="refer-form__input"
              @input="onCredentialsInput"
              :value="credentials"
              placeholder="华夏卡开户证件后六位"
            />
          </div>
          <div class="refer-form__row">
            <div class="refer-form__label">好友手机后六位:</div>
            <input
              class="refer-form__input"
              type="number"
              @input="onFriendMobileInput"
              :value="friendMobile"
              placeholder="好友手机后六位"
            />
          </div>
        </div>
        <div class="refer-form__submit" @click="onSubmit">立即提交</div>
      </div>
      <div class="refer-rules">
        <div class="refer-rules__title">活动规则：</div>
        <div class="refer-rules__row">
          <span class="rules-number">1.</span>
          活动时间：2022.04.01-2023.12.31
        </div>
        <div class="refer-rules__row">
          <div>
            <span class="rules-number">2.</span> <span>活动形式：</span>
          </div>
          <div>
            <div class="rules-li">（1）介绍人扫码报名并提交信息</div>
            <div class="rules-li">
              （2）提醒好友在报名当月开卡达标或提升金融资产至更高等级
            </div>
            <div class="rules-li">
              （3）次月15日后，介绍人可登录分行权益平台凭积分兑换宣传品
            </div>
          </div>
        </div>
        <div></div>
        <table class="refer-rules__table" border="0" cellspacing="0">
          <tr>
            <th>成功转介</th>
            <th class="second-th">介绍人可得积分</th>
          </tr>
          <tr>
            <td>1户贵宾（金融资产月日均20万元以上）</td>
            <td class="red">50积分</td>
          </tr>
          <tr>
            <td>1户财富（金融资产月日均60万元以上）</td>
            <td class="red">100积分</td>
          </tr>
          <tr>
            <td>1户高净值（金融资产月日均300万元以上）</td>
            <td class="red">200积分</td>
          </tr>
          <tr>
            <td>1户私行（金融资产月日均600万元以上）</td>
            <td class="red">300积分</td>
          </tr>
        </table>
        <div class="refer-rules__row">
          <span class="rules-number">3.</span
          >介绍人仅限：深圳分行贵宾级别及以上用户
        </div>
        <div class="refer-rules__row">
          <span class="rules-number">4.</span
          >积分有效期：3个月有效，逾期作废
        </div>
        <div class="refer-rules__row">
          <span class="rules-number">5.</span
          >活动宣传品：京东E卡或沃尔玛卡，数量有限，先到先得
        </div>
        <div class="refer-last-tip">
          活动详询华夏银行深圳分行各营业网点或您的专属客户经理
        </div>
      </div>
    </div>
    <div class="refer-bottom"></div>
  </div>
</template>

<script>
import { reactive, toRef, getCurrentInstance, onMounted } from 'vue'
import { Toast, Dialog } from 'vant'
import api from '@/api'

export default {
  setup() {
    const { proxy } = getCurrentInstance()
    const data = reactive({
      mobile: '',
      credentials: '',
      friendMobile: ''
    })

    const onMobileInput = e => {
      const value = e.target.value.toString()
      if (value.length > 6) {
        data.mobile = value.slice(0, 6)
        proxy.$forceUpdate()
        return
      }
      data.mobile = value
    }

    const onCredentialsInput = e => {
      const value = e.target.value.toString()
      if (value.length > 6) {
        data.credentials = value.slice(0, 6)
        proxy.$forceUpdate()
        return
      }
      data.credentials = value
    }

    const onFriendMobileInput = e => {
      const value = e.target.value.toString()
      if (value.length > 6) {
        data.friendMobile = value.slice(0, 6)
        proxy.$forceUpdate()
        return
      }
      data.friendMobile = value
    }

    const onSubmit = async () => {
      if (!data.mobile) {
        Toast('请输入华夏卡预留手机后六位')
        return
      }
      if (!data.credentials) {
        Toast('请输入华夏卡开户证件后六位')
        return
      }
      if (!data.friendMobile) {
        Toast('请输入好友手机后六位')
        return
      }
      console.log('data.mobile', data.mobile)
      if (data.mobile.toString().length !== 6) {
        Toast('华夏卡预留手机只需输入后六位')
        return
      }
      if (data.credentials.toString().length !== 6) {
        Toast('华夏卡开户证件只需输入后六位')
        return
      }
      if (data.friendMobile.toString().length !== 6) {
        Toast('好友手机只需输入后六位')
        return
      }

      const res = await api.saveSurvey({
        projectCode: 100102,
        code: 'hxszzjyl',
        content: `${data.mobile},${data.credentials},${data.friendMobile}`
      })
      if (res.error) {
        Toast(res.error.message)
        return
      }

      Dialog.alert({
        message: '提交成功'
      })
    }

    onMounted(async () => {
      document.title = ''
    })

    return {
      mobile: toRef(data, 'mobile'),
      credentials: toRef(data, 'credentials'),
      friendMobile: toRef(data, 'friendMobile'),
      onMobileInput,
      onCredentialsInput,
      onFriendMobileInput,
      onSubmit
    }
  }
}
</script>

<style lang="less" scoped>
.refer {
  min-height: 100vh;
  background: #c93833;
  overflow: hidden;

  .refer-head {
    pointer-events: none;
    width: 375px;
    height: 308px;
    background-image: url('../../assets/refer_head.png');
    background-repeat: no-repeat;
    background-size: 100%;
    position: absolute;
    top: 0;
    left: 0;
    .refer-head-text {
      width: 257px;
      height: 59px;
      margin-top: 88px;
      margin-left: 60px;
      background-image: url('../../assets/refer_head_text.png');
      background-size: 100%;
      background-repeat: no-repeat;
    }
    .refer-title {
      font-size: 17px;
      font-family: Source Han Sans CN;
      font-weight: 800;
      color: #ffffff;
      margin-top: 15px;
      text-align: center;
    }
  }

  .refer-main {
    background-color: #f6e6c9;
    margin: 0 15px;
    margin-top: 202px;
    padding-bottom: 20px;
    background-image: url('../../assets/refer_wash_painting.png');
    background-position: left bottom;
    background-repeat: no-repeat;
    background-size: 72% 13%;
    .refer-form {
      width: 325px;
      height: 236px;
      background-image: url('../../assets/refer_form.png');
      background-size: 100%;
      background-repeat: no-repeat;
      margin-left: 10px;
      overflow: hidden;
      .refer-form__title {
        font-size: 21px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #ffffff;
        margin-top: 10px;
        text-align: center;
      }
      .refer-form__content {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 34px;
        .refer-form__row {
          display: flex;
          align-items: center;
          margin-top: 7px;
          .refer-form__label {
            width: 140px;
            font-size: 15px;
            font-family: Source Han Sans CN;
            font-weight: 500;
            color: #000000;
          }
          .refer-form__input {
            width: 123px;
            height: 25px;
            background: #ffffff;
            border: 1px solid #999999;
            border-radius: 0;

            padding: 0;
            padding-left: 3px;

            font-size: 12px;
            font-family: Source Han Sans CN;
            font-weight: 500;
            color: #6f6f6f;
            -webkit-appearance: none;
          }
        }
      }
      .refer-form__submit {
        width: 79px;
        height: 30px;
        background: #fef4b3;
        border-radius: 13px;
        margin-left: 120px;
        margin-top: 8px;

        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #000000;
      }
      .refer-form__submit:active {
        opacity: 0.3;
      }
    }
    .refer-rules {
      margin: 20px 10px;

      .refer-rules__title {
        font-size: 15px;
        font-family: Source Han Sans CN;
        font-weight: 800;
        color: #000000;
      }
      .refer-rules__row {
        font-size: 12px;
        line-height: 14px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #000000;

        margin-top: 4px;
        .rules-number {
          font-family: Consolas, Monaco, Lucida Console, Liberation Mono,
            DejaVu Sans Mono, Bitstream Vera Sans Mono, Courier New, monospace;
        }
        .rules-li {
          font-size: 12px;
        }
        .red {
          color: #ff0005;
        }
      }
      .refer-rules__table {
        width: 325px;
        border: 1px solid #f6d486;
        margin: 8px 0;
        td {
          font-size: 11px;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #000000;
          border: 1px solid #f6d486;
          padding-left: 4px;
          text-align: center;
        }
        td.red {
          color: #bf0000;
        }
        th {
          font-size: 10px;
          font-family: Source Han Sans CN;
          font-weight: 800;
          color: #000000;
          border: 1px solid #f6d486;
        }
        .second-th {
          width: 90px;
        }
      }
      .refer-last-tip {
        margin-top: 20px;
        font-size: 8px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #000000;
        text-align: center;
      }
    }
  }
  .refer-bottom {
    width: 375px;
    height: 128px;
    background-image: url('../../assets/refer-bottom-cloud.png');
    background-size: 100%;
    background-repeat: no-repeat;
    margin-top: -90px;
  }
}
</style>
